import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const Input = ({
  className,
  defaultValue,
  error,
  label,
  name,
  value,
  required = false,
  type = "text",
  register,
  registerOptions = {},
  readOnly = false,
  disabled = false,
  uppercase = false,
  onChange,
  ...props
}) => {
  const mergedOnChange =
    uppercase || registerOptions.onChange || onChange
      ? (e) => {
          if (uppercase) {
            e.target.value = e.target.value.toUpperCase();
          }
          registerOptions?.onChange?.(e);
          onChange?.(e);
        }
      : undefined;

  const options = {
    required,
    ...registerOptions,
    ...(mergedOnChange ? { onChange: mergedOnChange } : {}),
  };

  return (
    <div className={`${fieldContainer} ${className || ""}`}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <input
        type={type}
        id={name}
        className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
        placeholder={props.placeholder || ""}
        {...register(name, options)}
        value={value}
        defaultValue={defaultValue}
        readOnly={readOnly}
        disabled={disabled}
        {...props}
      />

      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default Input;
